import { yupResolver } from '@hookform/resolvers/yup';
import { enqueueSnackbar } from 'notistack';
import React, { useState } from 'react';
import { Resolver, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { ELanguage } from '../../../../shared/enums/user/ELanguage';
import { ERole } from '../../../../shared/enums/user/ERole';
import { handleError } from '../../../../shared/functions/handleError';
import { IUser } from '../../../../shared/interfaces/user/IUser';
import { AdminEmployeeService } from '../service';
import { userSchema } from './EmployeeUpdate';
import EmployeeTabs from './tabs/EmployeeTabs';

const EmployeeCreate = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const {
    handleSubmit,
    control,
    watch,
    formState: { errors },
  } = useForm<IUser>({
    resolver: yupResolver(userSchema) as unknown as Resolver<IUser>,
    defaultValues: {
      dateOfJoin: new Date().toISOString(),
      birthday: new Date().toISOString(),
      role: ERole.USER,
      language: ELanguage.GB,
    },
  });
  const [file, setFile] = useState<File | null>(null);
  const [files, setFiles] = useState<FileList | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const submitHandler = async (state: IUser) => {
    const formData = new FormData();
    formData.append('body', JSON.stringify(state));
    if (file) {
      formData.append('file', file);
    }
    if (files) {
      for (const file of files as unknown as []) {
        formData.append('files', file);
      }
    }
    setIsLoading(true);
    await AdminEmployeeService.create(formData)
      .then((response) => {
        if (response) {
          navigate('/admin/employees');
          enqueueSnackbar(
            t('toasts.successfullyCreated', { title: response?.displayName }),
            { variant: 'success' },
          );
        }
      })
      .catch(handleError)
      .finally(() => setIsLoading(false));
  };
  return (
    <form onSubmit={handleSubmit(submitHandler)}>
      <EmployeeTabs
        isLoading={isLoading}
        control={control}
        errors={Object.keys(errors)}
        watch={watch}
        file={file}
        setFile={setFile}
        files={files}
        setFiles={setFiles}
      />
    </form>
  );
};

export default EmployeeCreate;
